import { useState, useEffect } from "react";
import { useIntl } from "react-intl";

import { useFormik } from "formik";

import getAllProducts from "@app/services/products/getAllProducts";

import { useToast } from "@hooks/useToast";

export const useCouponForm = ({
  isUpdateForm,
  onSubmit,
  validationSchema,
  initialData,
}) => {
  const { messages } = useIntl();

  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const { showErrorToast } = useToast();

  const formik = useFormik({
    initialValues: initialData,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
  });

  const filteredProducts = searchQuery
    ? products.filter(product =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : products;

  const submitButtonLabel = isUpdateForm
    ? messages.label_save
    : messages.label_create;

  const handleOnComplete = event => {
    const { query = "" } = event;

    if (!query.trim().length) {
      return;
    }

    setSearchQuery(query);
  };

  const handleRadioButtonChange = event => {
    const { value, target: { name = "" } = {} } = event;

    if (!value) {
      return;
    }

    formik.setFieldValue(name, value);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data: { data: allProducts = [] } = {} } = await getAllProducts(
          `?orderBy[listing_order]=asc&filter[type]=service&per_page=1000`
        );
        const formattedProducts = allProducts.map(({ id, name }) => ({
          code: id,
          name,
        }));

        setProducts(formattedProducts);
      } catch (error) {
        showErrorToast(messages.exception_error_message);
      }
    };

    fetchProducts();
  }, [messages, showErrorToast]);

  return {
    filteredProducts,
    formik,
    handleOnComplete,
    submitButtonLabel,
    handleRadioButtonChange,
  };
};
